import { Instance } from 'mobx-state-tree';
import { ProjectDispatchedRoutesDtoModelBase } from './ProjectDispatchedRoutesDtoModel.base';

/* The TypeScript type of an instance of ProjectDispatchedRoutesDtoModel */
export interface ProjectDispatchedRoutesDtoModelType extends Instance<typeof ProjectDispatchedRoutesDtoModel.Type> {}

/* A graphql query fragment builders for ProjectDispatchedRoutesDtoModel */
export { selectFromProjectDispatchedRoutesDto, projectDispatchedRoutesDtoModelPrimitives, ProjectDispatchedRoutesDtoModelSelector } from './ProjectDispatchedRoutesDtoModel.base';

/**
 * ProjectDispatchedRoutesDtoModel
 *
 * Dispatched routes in project
 */
export const ProjectDispatchedRoutesDtoModel = ProjectDispatchedRoutesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
